<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" app :style="{ backgroundImage: `url(${require('@/assets/images/verde.png')})`, backgroundSize: 'cover' }" color="blue-darken-3" :rail="rail">

            <v-list-item :prepend-avatar="image_Path" :title="'REAFUC'" nav height="50" @click="rail = false">

                <template v-slot:append>
                    <v-btn variant="text" icon="mdi-chevron-left" @click.stop="rail = !rail"></v-btn>
                </template>

            </v-list-item>

            <v-divider></v-divider>
            <v-list density="compact" nav>
                <div class="d-flex flex-column justify-center align-center my-2">
                    <v-avatar :image="image_Path" size="90"></v-avatar>
                    <!-- <p class="text-subtitle-1">Usuario</p> -->
                    <span v-if="userData">
                        {{ userData.email }}
                    </span>
                </div>

            </v-list>
            <v-divider></v-divider>

            <v-list>
                <v-list-group>
                    <template v-for="(menu, index) in datos" :key="index">
                        <v-list-group :key="index" v-if="shouldShowMenu(menu)" rounded="xl" color="white darken-1">
                            <template v-slot:activator="{ props }">
                                <v-list-item v-bind="props">
                                    <v-icon :icon="menu.icono"></v-icon>
                                    {{ menu.nombre }}
                                </v-list-item>
                            </template>

                            <template v-for="(submenu, subindex) in filteredSubmenus(menu.id)" :key="subindex">
                                <v-list-item :to="submenu.enlace" :value="submenu.nombre" rounded="xl">
                                    <v-icon :icon="submenu.icono"></v-icon>
                                    {{ submenu.nombre }}
                                </v-list-item>
                            </template>
                        </v-list-group>
                    </template>
                </v-list-group>
            </v-list>

        </v-navigation-drawer>

        <AppBar @openByCloseNavigationDrawerEmit="openByCloseNavigationDrawer" />
        <v-main class="ma-3">
            <slot></slot>
        </v-main>

    </v-app>
</template>
<script>
import { defineComponent } from 'vue';
import Login from "@/http/services/Login";
import Menus from "@/http/services/Menus";

import AppBar from '@/layouts/AppBar.vue';

export default defineComponent({

    data() {
        const menus_obj = new Menus();
        const submenus_obj = new Menus();

        const userlogeado = new Login();
        const userrolelogeado = new Login();

        return {
            user: [],
            sidebarOpen: true,
            login: new Login(),
            dialog: false,
            datos: [],
            datosub: [],
            menus_obj,
            submenus_obj,

            userlogeado,
            userrolelogeado,
            userData: null,
            roluserData: null,

            change_table: null,

            drawer: true,
            rail: false,
            image_Path: require('@/assets/images/mindef.png'),

        };
    },
    mounted() {
        this.registros();
        this.getUserData();
        this.getUserRolData();
    },
    computed: {
        filteredSubmenus() {
            return (menuId) => {
                return this.datosub.filter(submenu => submenu.submenu === menuId);
            };
        }
    },
    components: {
        AppBar,
    },
    methods: {
        openByCloseNavigationDrawer() {
            this.drawer = !this.drawer;
        },
        async getUserData() {
            try {
                const user = await this.userlogeado.userme();
                this.userData = user;
                console.log("Este es el usuario", this.userData);
            } catch (error) {
                console.error("Error al obtener los datos del usuario:", error);
            }
        },
        //Aqui estoy detectando lso datos del usuario logueado con su respectivo ROL
        async getUserRolData() {
            try {
                const user = await this.userrolelogeado.userroleauth();
                this.roluserData = user;
                console.log("Este es el usuario", this.roluserData);
            } catch (error) {
                console.error("Error al obtener los datos del usuario:", error);
            }
        },

        shouldShowMenu(menu) {
            return menu.enlace === '/' && this.filteredSubmenus(menu.id).length > 0;
        },
        async registros() {
            this.change_table = "cyan";
            try {
                /* const response = await this.menus_obj.menuget();
                        console.log("Quiero ver la respuesta", response); */
                const response = await this.menus_obj.rolusermenuget();
                console.log("Quiero ver la respuesta", response);

                /* const responsesub = await this.submenus_obj.submenuget();
                console.log("Esta es la respuesta", responsesub); */
                const responsesub = await this.submenus_obj.rolusersubmenuget();
                console.log("Esta es la respuesta", responsesub);

                if (response.status) {
                    this.datos = response.records;
                    console.log("Esta es la respuesta de personas status", this.datos);
                } else {
                    console.error("Respuesta inválida o sin registros.");
                }

                if (responsesub.status) {
                    this.datosub = responsesub.records;
                    console.log("Esta es la respuesta de personas status", this.datosub);
                } else {
                    console.error("Respuesta inválida o sin registros.");
                }

                // Mostrar el id de cada menú
                const idsMenus = this.datos.map((menu) => menu.id);
                console.log(`ID del menú general: `, idsMenus);

                this.datos.forEach((menu) => {
                    console.log(`ID del menú: ${menu.id}`);
                });

                // Mostrar el id de cada submenú
                this.datosub.forEach((submenu) => {
                    console.log(`ID del submenú: ${submenu.id}`);
                    console.log(`ID del menú asociado al submenú: ${submenu.submenu}`);
                });

                this.change_table = null;
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        },
        async cerrarSesion() {
            const estado = await this.login.logout();
            if (estado.status) {
                this.$router.push("login-puertos");
            }
        },
    },
});
</script>
